import { ProfileDto } from "@dialogics/shared/dto/types.ts"
import { createApi } from "@reduxjs/toolkit/query/react"
import { DTO } from "../../app/types.ts"
import { baseQueryWithReauth } from "../../app/utils"

// Define base query with token refresh logic

// RTK Query API using cookies for authentication
export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: baseQueryWithReauth({ baseUrl: "/api/auth" }),
  endpoints: builder => ({
    login: builder.mutation({
      query: credentials => ({
        url: "/login",
        method: "POST",
        body: credentials,
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: "/logout",
        method: "POST",
      }),
    }),
    refresh: builder.mutation({
      query: () => ({
        url: "/refresh",
        method: "POST",
      }),
    }),
    profile: builder.query<DTO<ProfileDto>, void>({
      query: () => `/profile`,
    }),
  }),
})
export const { useLoginMutation, useLogoutMutation, useRefreshMutation, useProfileQuery, useLazyProfileQuery } = authApi
